import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import nikenz from "../../Assets/Projects/nikenz.png";
import metronz from "../../Assets/Projects/metronz.png";
import jimsondev from "../../Assets/Projects/jimsondev.png";
import levelupnz from "../../Assets/Projects/levelupnz.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white", fontSize: "23px"  }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={nikenz}
              isBlog={false}
              title="NikeNZ"
              description = "Explore the latest Nike trends with our sleek React.js and Tailwind CSS website. Shop effortlessly for athletic gear, footwear, and accessories. Experience seamless browsing and quick checkouts."
              ghLink=""
              demoLink="https://nikenz.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={metronz}
              isBlog={false}
              title="MetroNZ Rental Property Management"
              description="Efficient property management made easy. Utilizing Next.js and Tailwind CSS, this platform simplifies rental management tasks. Manage properties seamlessly, track payments, and streamline communication with tenants."
              ghLink="https://github.com/JimsonXD/metro-rental-property-frontend"
              demoLink="https://metronz.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={levelupnz}
              isBlog={false}
              title="LevelUpNZ"
              description="Online code and markdown editor build with react.js. Online Editor which supports html, css, and js code with instant view of website. Online markdown editor for building README file which supports GFM, Custom Html tags with toolbar and instant preview.Both the editor supports auto save of work using Local Storage"
              ghLink=""
              demoLink="https://levelupnz.netlify.app/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={jimsondev}
              isBlog={false}
              title="Jimson's Portfolio"
              description="Online code and markdown editor build with react.js. Online Editor which supports html, css, and js code with instant view of website. Online markdown editor for building README file which supports GFM, Custom Html tags with toolbar and instant preview.Both the editor supports auto save of work using Local Storage"
              ghLink=""
              demoLink="https://jimsondev.netlify.app/"              
            />
          </Col>

          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
